/* eslint-disable */

import logo from './logo.svg';
import './App.css';
import { useState } from 'react';

function App() {

  let logo =  'React blog'
  let [글제목, 글제목변경] = useState(['남자 코트 추천','패딩 추천','맛집 추천']);
  let [따봉, 따봉변경] = useState([0,0,0]);
  let [modal, setModal] = useState(false);
  let [title,setTitle] = useState(0);

  [1,2,3].map(function(a){

  });

  return (
    <div className="App">
     <div className='black-nav'>
      <h4>{logo}</h4>
     </div>

     <button onClick={()=>{
      let sort = [...글제목];
      sort.sort();
      글제목변경(sort);
     }}>가나다순 정렬</button>

     <button onClick={()=>{
      let copy = [...글제목];
      copy[0]='여자 코트 추천';
      글제목변경(copy);
     }}>수정버튼</button>

    {
      글제목.map(function(a,i){
        return(
          <div className='list' key={i}>
      <h4 onClick={()=>{
        modal==false?setModal(true):setModal(false);
        setTitle[i]
      }}>{글제목[i]} <span className='good' onClick={()=>{
        let copy = [...따봉];
        copy[i]=copy[i]+1;
        따봉변경(copy)
        }}>👍</span> {따봉[i]} </h4>
      <p>2월 17일 발행</p>
    </div>
        )
      })
    }

    <button onClick={()=>{setTitle(0)}}>글제목0</button>
    <button onClick={()=>{setTitle(1)}}>글제목1</button>
    <button onClick={()=>{setTitle(2)}}>글제목2</button>

    {
      modal==true ? <Modal title={title} 글제목={글제목}/> : null
    }

    
   
    </div>
  );
}

function Modal(props){
    return (
      <div className='modal'>
        <h4>{props.글제목[props.title]}</h4>
        <p>날짜</p>
        <p>상세내용</p>
        <button>글수정</button>
      </div>
    )
}


export default App;
